import { Directive, HostListener, Input } from '@angular/core';
import { AnalyticsService } from '../services/utils/analytics.service';

@Directive({
  selector: '[defTrackEvent]',
})
export class TrackEventDirective {

  @Input() defTrackEvent: { category: string; action: string; label?: string; value?: number };

  constructor(private analytics: AnalyticsService) { }

  /**
   * This method is triggered when affixed to HTML elements of type <button>, <a>, etc.
   */
  @HostListener('click')
  onClick(): void {
    if (this.defTrackEvent.category && this.defTrackEvent.action) {
      this.analytics.trackEvent(
        this.defTrackEvent.category,
        this.defTrackEvent.action,
        this.defTrackEvent.label,
        this.defTrackEvent.value,
      );
    }
  }
}
